import { Skeleton } from '@pennfoster/pfc-design-system';

export function StatusChipSkeleton() {
  return <Skeleton variant={'rounded'} width={105} height={24} />;
}
